import React from "react";
import "./index.css";

function SkeletonLoader() {
  return (
    <div className="loader-container">
      <div></div>
      <div className="card">
        <div className="card-img skeleton"></div>
      </div>
    </div>
  );
}

export default SkeletonLoader;
